import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api/api.service';
import { Nationality } from '@precheckin/models/nationality.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NationalitiesService {
  private endpoint = `nationalities`;

  constructor(private apiService: ApiService) { }

  public get(search?: string): Observable<Nationality[]> {
    let params = new HttpParams();
    if (search) {
      params = params.append('search', search);
    }

    return this.apiService.get<Nationality[]>(`${this.endpoint}`, { params });
  }
}
